export const contribLabelMap = {
  target_activity_duration: "Coding activity",
  target_rest: "Breaks",
  target_work_hours: "Working hours",
  penalize_default_branch_usage: "Branch usage",
};
